<template >
  <div>     
    
    <v-container grid-list-xl> 
        
        <br><br><br>
        <v-card :height="vs.height-250" flat color="transparent">
            <v-layout fill-height align-center="" justify-center="">
                <v-col sm="8" cols="12">
                    <v-card>
                        <!-- <v-card-title >
                          <v-tabs
                            v-model="tab"
                             >
                                <v-tab to="/login" >
                                    Login
                                </v-tab>
                                 <v-tab to="/register" >
                                    Register
                                </v-tab>
                            </v-tabs>  
                        </v-card-title> -->
                        <v-card-actions class="pt-10">
                            <v-layout justify-center="" align-center="" >
                                <v-img  
                                    class="" 
                                    height="100"  
                                    max-width="100"
                                    :src="not.noImg"
                                /> 
                            </v-layout>
                        </v-card-actions>
                        <v-card-text>
                            <form id="logFom" class="py-5" @submit.prevent="onSubmit()">
                                <div class="font-weight-bold font-italic pb-3">Enter your Login details</div>
                                <div v-if="response.type">
                                    <v-alert :type="response.type" >
                                        <ul>
                                            <div v-for="(item, index) in response.res" :key="index">
                                                <li >{{item}}</li> 
                                            </div>
                                        </ul>
                                    </v-alert> 
                                </div>
                                
                                <v-row class="">  
                                    <v-col class="py-0" cols="12" sm="12">
                                        <v-text-field required
                                            @input="restartRes()"  
                                            type="email"
                                            v-model="input.email"
                                            label="Email"
                                            filled=""
                                            clearable
                                        ></v-text-field>
                                    </v-col>
                                     
                                    <v-col class="py-0" cols="12" sm="12">
                                        <v-text-field required 
                                            @input="restartRes()"  
                                            label="Password"
                                            v-model="input.password"
                                            filled=""
                                            clearable
                                            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                            :type="showPassword ? 'text' : 'password'"
                                            @click:append="showPassword = !showPassword"
                                        ></v-text-field>
                                    </v-col> 
                                </v-row>
                                <v-layout row wrap class="px-3">
                                    <v-spacer></v-spacer>
                                    <v-btn :loading="input.loading"  type="submit" color="primary">Login</v-btn>
                                </v-layout>
                            </form>
                        </v-card-text>
                    </v-card>
                <br><br><br>
                </v-col>  
            </v-layout> 
        </v-card>
    </v-container> 
    
  </div> 
</template>

<script>
let pageName = "Login"
    export default {
        name:pageName,
        props:["not"],
        data() {
            return {
                page_show:false,
                dialogMessage: false,
                load:false,
                input:{
                    password:'',
                    email:'',
                    loading:false
                },
                showPassword:false,
                tab: null,
                items: [
                    'Login', 'Register', ,
                ], 
                response:{
                    type:"",
                    res:[], 
                }
            }
        },
        created() {
            this.EventBus.$on('notYesDialog', this.notYesDialog);
        },
        mounted() { 
            this.show()
        },
        computed: {
            vs(){
                return this.$vuetify.breakpoint
            },  
            us(){
                return this.not.us
            },
            loading(){  
                return this.not.loading
            },
            processes(){  
                return this.not.processes
            }, 
            responses(){  
                return this.not.responses
            },
        },
        methods: {
            clicked(){},
             notYesDialog(action){
                if (action) {
                    if (action.code ===pageName+':'+1) { 
                        //this.not.go("/")
                    }else if (action.code===pageName+':'+2) {
                        this.input = {} 
                        this.restartRes()
                    }else if (action.code ===pageName+':'+3) {
                        this.restartRes() 
                        this.$store.dispatch("fi_signWithEmail",this.input)  
                    }else if (action.code ===pageName+':'+4) {
                        
                    }
                }
            },
            onSubmit(){ 
                this.restartRes("error") 
                if (!this.input.password) {
                    this.response.res.push("password is required")
                }
                if (!this.input.email) {
                    this.response.res.push("Email is required")
                } 
                if(this.response.res.length == 0) { 
                    this.restartRes() 
                    this.$store.dispatch("fi_signWithEmail",this.input)  
                } 
            },
            restartRes(type){
                if (type) {
                    this.response = {
                        type:type,
                        res:[], 
                    }
                }else{
                    this.response = {
                        type:"",
                        res:[], 
                    }
                } 
            },

            show(){
                if (this.us) { 
                    this.not.go("/")
                }
            },
            //LOAD
            pageLoad(t){
                if (!t) {
                    t=400
                }
                setTimeout(()=>{
                    let us = this.loggedUser 
                    let ps = this.processes
                    let ld = this.loading
                    let res = this.responses 

                    //CHECK USER STATE 
                    if (ps) {
                        let signing = ps.find(process=>{
                            return process.name == 'signing/withEmail'
                        }) 

                        if (signing) {
                            this.input.loading = true
                            this.not.notDialogP(true,true,"Loging..")
                        }else{
                            this.input.loading = false
                            this.not.notDialogP(false)
                        }  
                    }else{
                        this.page_show =true
                    }

                    //check response
                    if (res.res==='signing/withEmail/successful') { 
                        this.restartRes("success")
                        this.response.res = ["Successfully logged"]
                        this.not.notDialog(true,true,'Successful','You have Successfully login.','','OK',{code:pageName+':'+1}) 
                        this.not.notDialogP(false)  
                        this.not.restartResponses()

                        setTimeout(() => {
                            this.not.go("/")
                        }, 1000);
                    }else if (res.res==='signing/withEmail/error'){
                        let sms = null
                        let code = null
                        if (res.val.code==="auth/user-not-found") {
                            sms = "Wrong user email or password."
                            code = pageName+':'+2
                        }else if (res.val.code==="auth/network-request-failed") {
                            sms = "Network error, please make sure you have a working network and try again."
                            code = pageName+':'+3
                        }else if (res.val.code==="auth/wrong-password") {
                            sms = "Wrong password."
                            code = pageName+':'+2
                        } else {
                            sms = "Something went wrong while trying to login. Please, try again later"
                            code = pageName+':'+4
                        }  
                        this.restartRes("error")
                        this.response.res = ["Something went wrong"]
                        this.not.notDialog(true,true,'ERROR',sms,'','OK',{code:code}) 
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    }
                },t)
            }
            
        },
        watch: {
            us(v){
                //this.show()
            },
            loading(value){
                this.pageLoad(1)
            },
            processes(value){
                this.pageLoad(1)
            },
            responses(value){
                this.pageLoad(1) 
            } 
        },
  }
</script>
 
